/**
 * Every design is generated as a fixed 3:2 image at 1K resolution, i.e.
 * 1264×848. Downloads and upscales always operate on a freshly generated
 * image, so these dimensions are a hard contract rather than something we
 * measure at runtime. Update here if the generation aspect ratio/resolution
 * ever changes.
 */
export const GENERATED_IMAGE_DIMENSIONS = {
  width: 1264,
  height: 848,
} as const;

/** Cap on reference images attached to a generation/refinement, enforced by
 *  the home page upload and the refine prompt bar. */
export const MAX_REFERENCE_IMAGES = 2;

/** CSS 3:2. Gemini's 1K "3:2" is 1264×848 (~1.49), so treat nearby
 *  ratios as output-sized — object-contain would leave thin side gaps. */
const OUTPUT_ASPECT_RATIO = 3 / 2;
const OUTPUT_ASPECT_SLACK = 0.02;

export function isOutputAspectRatio(width: number, height: number): boolean {
  if (height <= 0) return false;
  return Math.abs(width / height - OUTPUT_ASPECT_RATIO) < OUTPUT_ASPECT_SLACK;
}
